import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BankService } from '../../services/bank.service';
import { Router } from '@angular/router';
import { event } from 'jquery';

@Component({
  selector: 'app-reject-loan-dialogue',
  templateUrl: './reject-loan-dialogue.component.html',
  styleUrls: ['./reject-loan-dialogue.component.scss']
})
export class RejectLoanDialogueComponent implements OnInit {


  returnLoanForm: FormGroup | any;
  returnReasonArr: any = [
    {id:1,reason:	'Panchasutras are not being followed by the SHG'},
    {id:2, reason:	'Details of members/Leaders are not correct'},
    {id:3, reason: 'KYC Documents of all the members not submitted/not matched'},
    {id:4, reason: 'The submitted application does not belong to our branch'},
    {id:5, reason: 'Not eligible as per the grading norms'},
    {id:6, reason:'No Income Generation Activity in the MCP for more than 2 Lakh Loan Amt.'},
    {id:7, reason: 'Financial Statements are not matching with books of records of the SHG'},
    {id:8, reason: 'Other'}];

  constructor(
    private dialogRef: MatDialogRef<RejectLoanDialogueComponent>,
    private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private snackBar: MatSnackBar,
    private bankService: BankService,
    private route: Router
  ) { }

  shgLoanId:string = ''

  ngOnInit(): void {
    this.createReturnLoanForm();
    this.shgLoanId = this.data?.shgLoanId;
    // console.log('Check Data: ',this.data , this.shgLoanId);

    this.updateValidation();
  }

  createReturnLoanForm () {
    this.returnLoanForm = this._formBuilder.group({
      reasonType: ['', Validators.required],
      rejectedReason: ['', Validators.required]
    });

    (this.returnLoanForm.get('reasonType') as FormControl).valueChanges.subscribe((reasonType: number) => {
      const rejectedReason = this.returnReasonArr.find((item: any) => item.id == reasonType)?.reason;

      this.returnLoanForm.patchValue({
        rejectedReason
      });
    });
  }

  submitReturnReason(data: any) {
    let xTenantId = this.data.xTenantId;
    let payload:any = {
      shgLoanId: this.shgLoanId,
      ...this.returnLoanForm.value
    }

    this.bankService.rejectLoan(xTenantId, payload).subscribe((res: any) => {
      if(res?.responseCode == 200){
        this.openSnackBar(res.responseDesc);
        this.dialogRef.close(true);
      // this.applicationListData = res?.wrapperList;
      // this.totalCount = res?.totalCount;
      this.route.navigate(['/admin/return'])
      }
    },((error:any) =>{
      // this.applicationListData = [];
      // this.totalCount = 0;
      // this.openSnackBar(error.errorMsg, 'Close', true);
    }));
    // console.log('Returned Reason Form: ', this.data, this.returnLoanForm );
  }

  openSnackBar(message: any, action = '', isError: boolean = false) {
    this.snackBar.open(message, action, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: [
        isError ? 'error-snackbar' : 'success-snackbar',
        'centered-snackbar',
      ],
    });
  }

  updateValidation(){
    (this.returnLoanForm.get('reasonType') as FormControl).valueChanges.subscribe((reasonType: number) => {
      const reasonControl = this.returnLoanForm.get('rejectedReason');
      if(reasonType == 8) {
        reasonControl?.setValidators([Validators.required]);
      }else{
        reasonControl?.clearValidators();
      }
      reasonControl?.updateValueAndValidity();
    });
  }

  closeRejectDialog() {
      this.dialogRef.close(false);
  }

}
